import { useMemo } from 'react';

import { useTracks } from '../contexts/TracksProvider';
import { isLocalId, isScreenId } from '../contexts/participantsState';

export const useVideoTrack = (id) => {
  const { videoTracks } = useTracks();
  const videoTrack = videoTracks?.[id];
  const state = videoTrack?.state;
  const subscribed = videoTrack?.subscribed;
  const persistentTrack = videoTrack?.persistentTrack;

  /**
   * Compared by fields and track identity, not deeply: with a video processor (background blur)
   * the track is a canvas capture whose `.canvas` reaches the whole DOM, and deep equality never ends.
   * A new MediaStreamTrack (P2P / SFU switch) is a new reference, so it still reaches the DOM.
   */
  return useMemo(() => {
    if (
      state === 'off' ||
      state === 'blocked' ||
      (!subscribed && !isLocalId(id) && !isScreenId(id))
    )
      return null;
    return persistentTrack;
  }, [id, state, subscribed, persistentTrack]);
};
